import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader } from "./primitives";

const Vesting = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-24 lg:py-32 border-t border-line" data-testid="vesting-section">
      <div className="section-shell">
        <SectionHeader
          index={5}
          eyebrow="Vesting"
          title="Disciplined Release Schedules"
          sub="Long-term alignment is enforced on-chain and by policy. Locks and release schedules for every allocation."
          testId="vesting-header"
        />
        <div className="mt-14 relative">
          <div className="absolute left-[7px] sm:left-[11px] top-2 bottom-2 w-px bg-line" aria-hidden="true" />
          <ol className="space-y-4">
            {config.vesting.map((v, i) => (
              <Reveal key={v.name} delay={i * 0.06} y={18} testId={`vesting-item-${i}`}>
                <li className="relative pl-10 sm:pl-14">
                  <span
                    className={`absolute left-0 top-5 h-[15px] w-[15px] sm:h-[23px] sm:w-[23px] rounded-full border-2 bg-navy ${
                      v.lock === "None" || v.lock === "Immediate" ? "border-teal" : "border-gold"
                    }`}
                    aria-hidden="true"
                  >
                    <span className={`absolute inset-[3px] sm:inset-[5px] rounded-full ${v.lock === "None" || v.lock === "Immediate" ? "bg-teal" : "bg-gold"}`} />
                  </span>
                  <div className="card-surface rounded-xl px-6 sm:px-8 py-5 sm:py-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-10">
                    <h3 className="font-display font-semibold text-mist text-base sm:text-lg sm:w-64 shrink-0 uppercase tracking-wide">{v.name}</h3>
                    <div className="flex flex-1 flex-col sm:flex-row gap-3 sm:gap-10">
                      <div>
                        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate">Initial Lock</div>
                        <div className={`mt-1 font-mono text-sm sm:text-base font-semibold ${v.lock === "None" || v.lock === "Immediate" ? "text-teal" : "text-gold"}`}>
                          {v.lock}
                        </div>
                      </div>
                      <div>
                        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate">Release</div>
                        <div className="mt-1 font-mono text-sm sm:text-base text-mist">{v.release}</div>
                      </div>
                    </div>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Vesting;
